module.exports = __webpack_public_path__ + "img/image_browsing_empty.2c72e357.png";